<template>
  <div class="tme-dialog" v-if="show">
    <div class="t-mask">
    </div>
    <div class="t-dialog">
      <div class="t-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="less" scoped>
  .tme-dialog{
    .t-mask{
      position: fixed;
      z-index: 1000;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
    }
    .t-dialog{
      max-width: 100%;
      width: 100%;
      height: 100%;
      background-color: transparent;
      position: fixed;
      display: table;
      z-index: 5000;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      text-align: center;
      border-radius: 3px;
      overflow: hidden;
      .t-content{
        width: 7.89333rem;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateY(-70%) translateX(-50%);
        transform: translateY(-70%) translateX(-50%);
        margin: 0 auto;
        
      }
    }
  }
</style>